import React from 'react';
import { brandOf } from '@playbook-technologies/landing-page-ui/brand';
import { LandingPageThemeId } from '@client/new/common/landingPageThemes';
import { FieldDesc } from './common';

export function brandColorNotice(
  color: string,
  themeId: LandingPageThemeId,
): { text: string; swatch: string } | null {
  if (!/^#[0-9a-f]{6}$/i.test(color)) return null;
  const brand = brandOf(color, themeId);
  if (brand.primaryFit === 'outlined')
    return {
      text: `The color you've selected may cause your buttons to disappear into the theme. To solve this, while maintaining your brand color, we'll outline your buttons with ${brand.primaryEdge.toUpperCase()}.`,
      swatch: brand.primaryEdge,
    };
  if (brand.primaryFit === 'shifted')
    return {
      text: `The color you've selected may cause your buttons to disappear into the theme. To solve this, we'll use an adjusted shade of it on your buttons, ${brand.primary.toUpperCase()}.`,
      swatch: brand.primary,
    };
  if (brand.primaryFit === 'accent')
    return {
      text: `The color you've selected may cause your buttons to disappear into the theme. To solve this, we'll use the theme's default color on your buttons, ${brand.primary.toUpperCase()}.`,
      swatch: brand.primary,
    };
  return null;
}

export function BrandColorNotice({
  color,
  themeId,
}: {
  color: string;
  themeId: LandingPageThemeId;
}) {
  const notice = brandColorNotice(color, themeId);
  if (!notice) return null;
  return (
    <div className="flex items-start gap-2 lg:max-w-[350px]">
      <span
        className="mt-[3px] h-[14px] w-[14px] shrink-0 rounded"
        style={{ backgroundColor: notice.swatch }}
      />
      <FieldDesc>{notice.text}</FieldDesc>
    </div>
  );
}
